import StatusMessage from './StatusMessage';

export default StatusMessage;
